<!-- Spacer -->
<div
    class="treo-vertical-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper"></div>
